/**
 * 读取 Blob/File 的二进制内容。
 *
 * 优先使用 Blob.arrayBuffer()；部分运行环境（如 jsdom、旧版 WebView）未实现该方法，
 * 此时退回 FileReader，保证测试与低版本浏览器行为一致。
 */
export async function blobToBytes(blob: Blob): Promise<Uint8Array> {
  if (typeof blob.arrayBuffer === 'function') {
    return new Uint8Array(await blob.arrayBuffer());
  }
  return new Promise<Uint8Array>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (result instanceof ArrayBuffer) resolve(new Uint8Array(result));
      else reject(new Error('文件读取结果不是二进制数据'));
    };
    reader.onerror = () => reject(reader.error ?? new Error('文件读取失败'));
    reader.readAsArrayBuffer(blob);
  });
}

export async function blobToText(blob: Blob): Promise<string> {
  if (typeof blob.text === 'function') return blob.text();
  const bytes = await blobToBytes(blob);
  return new TextDecoder('utf-8').decode(bytes);
}
